import React from 'react';
import styled from 'styled-components';

import Row from 'components/Common/Row';
import FleetOpsMark from 'images/fleetops-mark.svg';
import Typography from 'kingpin/atoms/Typography';

const Logo = styled.img`
  height: 21px;
  margin-right: 6px;
`;

/*
 * The "Powered By FleetOps" mark shown on wallboards. Unpositioned — the
 * caller decides where it sits (WallBoard pins it to the screen corner; the
 * Driver Leaderboard places it in its own footer).
 */
const PoweredByFleetOps = () => (
  <Row centerAlign>
    <Logo src={FleetOpsMark} alt="" />
    <Typography.Body type="Body 14">Powered By FleetOps</Typography.Body>
  </Row>
);

export default PoweredByFleetOps;
